import { AiAssistantButton } from '@elva/ai-chat';
import React from 'react';
import { Button } from '../Button/Button';
import { IconButton } from '../IconButton/IconButton';

export interface CalendarTopBarActionsProps {
  onOptions?: () => void;
  onBell?: () => void;
  /** When false, hides the Options control (e.g. Bird Eye View). Default true. */
  showOptions?: boolean;
  /** Number of active filters — shown as a badge on the Options button. */
  optionsBadge?: number;
}

/** Live / bell / Options / AI — top-right of calendar header. */
export function CalendarTopBarActions({
  onOptions,
  onBell,
  showOptions = true,
  optionsBadge = 0,
}: CalendarTopBarActionsProps) {
  return (
    <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
      <span className="glass-live inline-flex h-8 items-center gap-1.5 rounded-[var(--r-pill)] px-[11px]">
        <span className="relative inline-flex h-[7px] w-[7px]">
          <span className="absolute inset-0 rounded-full bg-[var(--success)]" />
          <span className="absolute inset-0 animate-ping rounded-full bg-[var(--success)] opacity-60" />
        </span>
        <span className="text-[11.5px] font-semibold text-[var(--success)]">Live</span>
        <span className="font-[var(--font-mono)] text-[11px] text-[var(--ink-3)]">now</span>
      </span>
      <IconButton icon="bell" size={32} onClick={onBell} label="Notifications" className="glass-control glass-control--sm" />
      {showOptions ? (
        <Button variant="secondary" size="sm" iconLeft="filter" onClick={onOptions} className="glass-control">
          Options
          {optionsBadge > 0 ? (
            <span
              aria-label={`${String(optionsBadge)} active filters`}
              className="ml-1.5 inline-flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-[var(--ai-3)] px-1 font-[var(--font-mono)] text-[10px] font-bold text-[var(--cream-0)]"
            >
              {optionsBadge}
            </span>
          ) : null}
        </Button>
      ) : null}
      <AiAssistantButton />
    </div>
  );
}
